export default "__VITE_ASSET__4rMrtHqV__"